import useData from './useData';
import * as DevicesAPI from '../api/devices';

const useDeviceTypes = () => useData(async () => (await DevicesAPI.getTypes()).data, []);

export default useDeviceTypes;
